module.exports = __webpack_public_path__ + "static/media/Mataicou.bce276a3.jpg";